import { AnimationClose } from 'components/AnimationClose/AnimationClose';
import { ModalFullContent } from 'components/ModalFullContent/ModalFullContent';
import { SecuritySchema } from 'components/SecuritySchema/SecuritySchema';
import type { SecuritySchemaDataSource } from 'components/SecuritySchema/model/SecuritySchemaDataSource';
import type { SecuritySchemaEntryPoint } from 'components/SecuritySchema/model/SecuritySchemaEntryPoint';
import type { HostIdentifier } from 'model/HostIdentifier';
import { useMemo } from 'react';
import type { FC } from 'react';

interface Props {
  entryPoint: SecuritySchemaEntryPoint;
  highlightedRuleLabel?: string;
  hostIdentifier: HostIdentifier;
  onClose?: () => void;
}

export const SecuritySchemaModal: FC<Props> = (props) => {
  const dataSource: SecuritySchemaDataSource = useMemo(
    () => ({ hostIdentifier: props.hostIdentifier }),
    [props.hostIdentifier],
  );
  return (
    <ModalFullContent>
      <div className='flex flex-1 flex-col bg-white'>
        <SecuritySchema
          breadcrumbsAddon={
            <AnimationClose
              onClick={() => {
                props.onClose?.();
              }}
            />
          }
          className='flex-1'
          entryPoint={props.entryPoint}
          highlightedRuleLabel={props.highlightedRuleLabel}
          dataSource={dataSource}
        />
      </div>
    </ModalFullContent>
  );
};
